/* Marketfit · Constructor de pack (Impulse) */
(function () {
  function box() { return document.querySelector('[data-mf-bundle]'); }
  function selectedOpt() { var b = box(); return b ? b.querySelector('input[name="mf-bundle"]:checked') : null; }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
    var b = box(); var opt = selectedOpt();
    if (!b || !opt || opt.value === 'solo') return;
    e.preventDefault(); e.stopImmediatePropagation();
    var mainId = form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value;
    var companionId = b.getAttribute('data-companion');
    var packName = opt.closest('.mf-bundle__opt').getAttribute('data-pack') || 'Pack';
    var giftEl = form.querySelector('input[name="properties[Regalo]"]');
    var gift = giftEl ? giftEl.value : null;
    if (!mainId || !companionId) return;
    var items = [
      { id: Number(mainId), quantity: 1, properties: gift ? { Regalo: gift, _pack: packName } : { _pack: packName } },
      { id: Number(companionId), quantity: 1, properties: { _pack: packName } }
    ];
    var btn = form.querySelector('[name="add"]'); if (btn) btn.setAttribute('aria-disabled', 'true');
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
      .catch(function () { window.location.href = '/cart'; });
  }, true);
})();
